import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useCashLocationStore } from "~/stores/use-cash-location-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import CashLocationForm from "./cash-location-form";

export default function CashLocationDialog() {
  const {
    selectedCashLocation,
    cashLocationDialogOpen,
    setCashLocationDialogOpen,
  } = useCashLocationStore();

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean) => {
    setCashLocationDialogOpen(open);
  };

  return (
    <Dialog open={cashLocationDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("CashLocation.cash_location")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <CashLocationForm
            cashLocation={selectedCashLocation}
            onClose={() => handleDialog(false)}
          />
        </div>
        <DialogFooter>
          <Button
            className="w-full"
            form="cash-location-form"
            type="submit"
            variant="success"
          >
            {selectedCashLocation ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
